import React from "react";

import Slider from "rc-slider";

import styles from "./style.module.css";

const colorsTwo = [
  "#D57DF5",
  "#7E69D7",
  "#2F80ED",
  "#56CCF2",
  "#52FFD3",
  "#5BCF74",
  "#96E964",
  "#FFCF71",
  "#F97255",
  "#FF84CE"
];

export default class ProfitSlider extends React.Component {
  allEqual(arr) {
    return arr.every((v) => v === arr[0]);
  }

  render() {
    const { data, current, onHover } = this.props;

    let marks = {};
    let dataMap = {};
    data &&
      data
        .sort((a, b) => b.value - a.value)
        .forEach((d, i) => {
          marks[Number(d.value)] = (
            <div
              className={styles.dotHolder}
              style={
                i == 0
                  ? { background: "#5BCF74" }
                  : i == data.length - 1
                    ? { background: "#D82149" }
                    : current === d.value
                      ? { background: "#512f77" }
                      : { background: "#868595" }
              }
              onMouseEnter={() => onHover(d.index)}
              onMouseLeave={() => onHover(undefined)}
            ></div>
          );

          dataMap[Number(d.value)] = d;
        });

    const max = data ? data.reduce((a, b) => Math.max(a, Math.round(b.value)), 0) : 0;
    const min = data ? data.reduce((a, b) => Math.min(a, Math.round(b.value)), Infinity) : 0;

    return (
      <div className={styles.impactSlider}>
        <div className={styles.sliderHolder} style={{ pointerEvents: "all", width: "100%" }}>
          <Slider
            marks={Object.keys(marks).length > 0 ? marks : undefined}
            min={min}
            max={max}
            included={false}
            trackStyle={{ backgroundColor: "transparent" }}
            handleStyle={{
              backgroundColor: "#F47C20",
              borderColor: "white",
              boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)",
              zIndex: 0,
              pointer: "cursor !important"
            }}
            value={current}
          />
        </div>
      </div>
    );
  }
}
